import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import AppTheme from '../shared-theme/AppTheme';
import AppAppBar from '../components/admin/AppAppBar';
import Hero from '../components/explore/ExploreHero';
import LogoCollection from '../components/landing/LogoCollection';
import Footer from '../components/landing/Footer';
import FilteredEvent from '../components/explore/filteredEvents';
import EventDetailsCompact from '../components/EventDetailsCompact';
import EventHero from '../components/EventHero';
import EventSlider from '../components/explore/EventSlider';


export default function Landing(props) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <AppAppBar />
      <Hero />
      <div>                
        <FilteredEvent />       
        <Divider />
        <LogoCollection />
        {/* <Divider /> */}
        <Footer />
      </div>
    </AppTheme>
  );
}
